import React from "react";
import { Label } from "../InputField1/InputFiled1Style";
import MultiSelect from "react-select";
import { MultiSelectStyle } from "./MultiSelectStyle";
export const SelectMulti = ({
  value,
  defaultValue,
  label,
  res,
  onChange,
  placeholder,
  IsScroll,
  onMenuOpen,
  isLoading,
  loadingMessage,
  inputRef,
  zIndex,
}) => {
  return (
    <MultiSelectStyle style={{ width: "100%" }} zIndex={zIndex}>
      <Label>{label}</Label>
      <MultiSelect
        defaultValue={
          defaultValue
            ? { defaultValue: defaultValue, label: defaultValue }
            : ""
        }
        value={value}
        isMulti
        ref={inputRef}
        options={res}
        onChange={onChange}
        isClearable
        placeholder={placeholder ? placeholder : "انتخاب کنید... "}
        menuPortalTarget={IsScroll ? document.body : null}
        onMenuOpen={onMenuOpen}
        isLoading={isLoading}
        loadingMessage={loadingMessage}
      />
    </MultiSelectStyle>
  );
};
